import { render, staticRenderFns } from "./PersonalDesarrolloProfesional.vue?vue&type=template&id=2fc74dfa&scoped=true"
import script from "./PersonalDesarrolloProfesional.vue?vue&type=script&lang=js"
export * from "./PersonalDesarrolloProfesional.vue?vue&type=script&lang=js"
import style0 from "./PersonalDesarrolloProfesional.vue?vue&type=style&index=0&id=2fc74dfa&prod&scoped=true&lang=css"
import style1 from "./PersonalDesarrolloProfesional.vue?vue&type=style&index=1&id=2fc74dfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc74dfa",
  null
  
)

export default component.exports